import styles from './Breadcrumbs.module.css';

interface BreadcrumbsProps {
  items: Array<{ id: string; name: string }>;
  onNavigate: (id: string) => void;
}

export default function Breadcrumbs({ items, onNavigate }: BreadcrumbsProps) {
  if (items.length === 0) return null;
  
  return (
    <nav className={styles.breadcrumbs}>
      {items.map((item, index) => (
        <span key={item.id} className={styles.item}>
          {index > 0 && (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          )}
          <button
            className={`${styles.link} ${index === items.length - 1 ? styles.current : ''}`}
            onClick={() => onNavigate(item.id)}
          >
            {item.name}
          </button>
        </span>
      ))}
    </nav>
  );
}

